"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_STORAGE_INPUT = void 0;
exports.INVALID_STORAGE_INPUT = 'InvalidStorageInput';
